import React from 'react';
import AppStoresLinksList from './AppStoresLinksList';
import SocialLinksList from './SocialLinksList';
import { LinkProps } from 'src/elements/links/2023_Q4/LinkBranded';
import { BottomGrid } from './FooterBottomGrid.styles';

interface FooterBottomGrid {
  colorScheme?: LinkProps['colorScheme'];
  colorSchemeVariant?: LinkProps['colorSchemeVariant'];
}

const FooterBottomGrid = ({ colorScheme, colorSchemeVariant }: FooterBottomGrid): JSX.Element => (
  <BottomGrid>
    <SocialLinksList />
    <AppStoresLinksList
      colorScheme={colorScheme}
      colorSchemeVariant={colorSchemeVariant}
    />
  </BottomGrid>
);

export default FooterBottomGrid;
